import React from "react";

// Chakra imports
import { Button, Flex, Text } from "@chakra-ui/react";

import { StripeClientId } from "../helpers/config";

export default function StripeBanner({ currentUser }) {
  const connectStripe = () => {
    const url = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${StripeClientId()}&scope=read_write&state=${
      currentUser.id
    }`;
    window.open(url, "_self");
  };

  return (
    <Flex
      direction="column"
      bg="linear-gradient(135deg, #3311DB 0%, #7551FF 100%)"
      bgSize="cover"
      py={{ base: "30px", md: "56px" }}
      px={{ base: "30px", md: "64px" }}
      borderRadius="30px"
    >
      <Text
        fontSize={{ base: "24px", md: "34px" }}
        color="white"
        mb="14px"
        maxW={{
          base: "100%",
        }}
        fontWeight="700"
        lineHeight={{ base: "32px", md: "42px" }}
      >
        Final step - connect to Stripe
      </Text>
      <Text
        fontSize="md"
        color="#E3DAFF"
        maxW={{
          base: "100%",
          md: "64%",
          lg: "40%",
          xl: "56%",
          "2xl": "46%",
          "3xl": "34%",
        }}
        fontWeight="500"
        mb="40px"
        lineHeight="28px"
      >
        We use Stripe to process your donations. Click the buttons below to
        connect your existing Stripe account, or create a new one.
      </Text>

      <Flex align="center">
        <Button
          bg="white"
          color="black"
          _hover={{ bg: "whiteAlpha.900" }}
          _active={{ bg: "white" }}
          _focus={{ bg: "white" }}
          fontWeight="500"
          fontSize="18px"
          py="25px"
          px="32"
          me="38px"
          onClick={connectStripe}
        >
          Connect to Stripe
        </Button>
      </Flex>
    </Flex>
  );
}
